import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import { linkifier } from 'react-linkifier';

function parse(p, useParser) {
  return useParser ? Parser(p) : linkifier(Parser(p));
}

function Text(props) {
  const { text, useParser } = props;
  return (
    <div className={props.className ? props.className : ''}>
      {text && Array.isArray(text)
        ? text.map(
            (p, i) =>
              p ? (
                <p key={`p-${i}`}>{parse(p, useParser)}</p>
              ) : (
                <br key={`p-${i}`} />
              )
          )
        : parse(text, useParser)}
    </div>
  );
}
Text.defaultProps = {};
Text.propTypes = {
  text: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  className: PropTypes.string,
  useParser: PropTypes.bool
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/ui/Text.jsx